"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Reason = void 0;
var Reason;
(function (Reason) {
    Reason[Reason["RFI"] = 1] = "RFI";
    Reason[Reason["OwnersRequest"] = 2] = "OwnersRequest";
    Reason[Reason["ValueEngineering"] = 3] = "ValueEngineering";
    Reason[Reason["ChangedConditions"] = 4] = "ChangedConditions";
    Reason[Reason["RequestForSubstitution"] = 5] = "RequestForSubstitution";
    Reason[Reason["RecognitionOfErrorOmission"] = 6] = "RecognitionOfErrorOmission";
    Reason[Reason["FieldConditions"] = 7] = "FieldConditions";
    Reason[Reason["DesignDocumentsChange"] = 8] = "DesignDocumentsChange";
    Reason[Reason["ImprovedInformation"] = 9] = "ImprovedInformation";
    Reason[Reason["Regulatory"] = 10] = "Regulatory";
})(Reason = exports.Reason || (exports.Reason = {}));
//# sourceMappingURL=Reason.js.map